var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckSmallBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2E67D1",
  fillRule: "evenodd",
  d: "M16.21 8.408a.75.75 0 0 1 .132 1.052l-5.25 6.75a.75.75 0 0 1-1.122.07l-2.25-2.25a.75.75 0 0 1 1.06-1.06l1.65 1.649 4.728-6.08a.75.75 0 0 1 1.053-.131",
  clipRule: "evenodd"
})));
export default SvgCheckSmallBlue;